<template>
  <div>Planes</div>
</template>